<template>
  <div v-if="data.opLoading">
    <ly-skeleton fromType="opStage" :row="2"></ly-skeleton>
  </div>
  <div class="page-comp-opportunity-stage" v-else-if="data?.stageId">
    <jw-card :bordered="false">
      <div class="stage-title">
        <span class="title">{{ $t('商机阶段') }}</span>
        <template v-if="hasPermission">
          <div v-if="['0', '1'].indexOf(data.allDetail.details.find((v) => v.value === data.allDetail?.currentStage)?.status) > -1 && hasPermission">
            <jw-button :disabled="lockedStatusOrigin" type="outline" v-if="data.boostStage === '1' && (data.progressStage.length - 2 != data.lastIndex || data.isFinishStage === -1) && !data.isLastShow" @click="moveToNextStage"> {{ $t('推进至下一阶段') }}</jw-button>
            <jw-button :disabled="lockedStatusOrigin" v-else-if="!data.allDetail.isSupportAcross && data.boostStage === '0'" @click="noMoveTo">{{ $t('推进至当前阶段') }}</jw-button>
            <jw-button :disabled="lockedStatusOrigin" v-else-if="data.allDetail.isSupportAcross && data.boostStage === '0'" @click="moveToNextStage" type="outline">{{ $t('推进至当前阶段') }}</jw-button>
            <jw-button :disabled="lockedStatusOrigin" type="outline" v-else-if="data.boostStage === '2'" status="warning" @click="backToCurrentStage">{{ $t('回退至当前阶段') }}</jw-button>
            <!-- <template v-else>
                <jw-button v-if="data.addClass == data.addClassIndex" type="outline" @click="stageEnd">结束</jw-button>
              </template> -->
          </div>
        </template>
      </div>
      <jw-steps type="arrow" :current="data.currentStage" small changeable class="stage-total-steps">
        <template v-for="(item, index) in data.progressStage" :key="item.id">
          <jw-step v-if="!item.final" @click="selectSteps(item, index)" :class="{ 'active-stage-custom': index == data.addClass, 'active-stage': item.value == data.allDetail?.currentStage }">
            <jw-space size="mini">
              <span class="stage-dot" :class="{ 'stage-dot-wait': item.status === '0', 'stage-dot-underway': item.status === '1', 'stage-dot-finished': item.status === '2' }"></span>
              <span class="stage-steps">{{ item.label }} </span>
              <span class="stage-steps-rate" v-if="data.showWinRate">{{ item.winRate }}%</span>
            </jw-space>
          </jw-step>
          <!-- 终极阶段 -->
          <jw-step v-if="item.final && data.finalStageValue.indexOf(data.allDetail.currentStage) === -1" @click="selectSteps(item, index, 'end')" :class="{ 'active-stage-custom': index == data.addClass && data.noCancel, 'active-stage': data.endStatus.value == data.allDetail?.currentStage && data.noCancel }">
            <!-- <jw-dropdown v-if="['60', '70', '80'].indexOf(data.allDetail?.currentStage) === -1 && hasPermission" @select="handleSelect($event, item)" :popup-max-height="false"> -->
            <jw-dropdown v-if="data.finalStageValue.indexOf(data.allDetail?.currentStage) === -1 && hasPermission" @select="handleSelect($event, item)" :popup-max-height="false">
              <jw-space size="mini">
                <span class="stage-dot" :class="{ 'stage-dot-wait': data.endStatus.status === '0', 'stage-dot-underway': data.endStatus.status === '1', 'stage-dot-finished': data.endStatus.status === '2' }"></span>
                <span class="stage-steps">{{ data.endStatus.label }}</span>
                <span class="stage-steps-rate" v-if="data.showWinRate && data.endStatus.winRate">{{ data.endStatus.winRate }}%</span>
                <icon-down />
              </jw-space>
              <template #content>
                <div v-for="subItem in data.finalStage" :key="subItem.id">
                  <jw-doption :disabled="lockedStatusOrigin" :value="subItem">
                    {{ subItem.label }}
                    <template v-if="data.showWinRate">{{ subItem.winRate }}%</template>
                  </jw-doption>
                </div>
              </template>
            </jw-dropdown>
            <jw-space v-else size="mini">
              <span class="stage-dot" :class="{ 'stage-dot-wait': data.endStatus.status === '0', 'stage-dot-underway': data.endStatus.status === '1', 'stage-dot-finished': data.endStatus.status === '2' }"></span>
              <span class="stage-steps">{{ data.endStatus.label }}</span>
              <span class="stage-steps-rate" v-if="data.showWinRate && data.endStatus.winRate">{{ data.endStatus.winRate }}%</span>
            </jw-space>
          </jw-step>
        </template>
      </jw-steps>
      <div class="stage-container">
        <div @click="data.unfold = !data.unfold" class="hand">
          <template v-if="data.finalStageValue.indexOf(data.stageProcess) === -1">
            <jw-space class="stage-header" v-if="data.tasks?.length">
              <icon-caret-down v-if="data.unfold" />
              <icon-caret-right v-else />
              <span>{{ $t('本阶段任务') }} {{ (data.tasks?.filter((el) => el.status == '2')).length }}/{{ data.tasks.length }}</span>
            </jw-space>
            <div class="stage-header" v-else>{{ $t('本阶段无任务') }}</div>
          </template>
          <div class="stage-header" v-else>
            <span>{{ $t('变更原因') }}：</span>
            <span>{{ data.allDetail.cause }}</span>
          </div>
        </div>
        <div v-if="data.unfold && data.tasks?.length" class="op-stage">
          <div v-for="(item, levelIndex) in data.tasks" class="stage-content-total" :key="item.id">
            <div class="stage-content-border">
              <div class="stage-content">
                <div class="stage-content-label">
                  <jw-space v-if="item.status === '0'" class="stage-content-waiting">
                    <icon-minus-circle />
                    <span>{{ $t('未开始') }}</span>
                  </jw-space>
                  <jw-space v-else-if="item.status === '1'" class="stage-content-underway">
                    <icon-schedule />
                    <span>{{ $t('进行中') }}</span>
                  </jw-space>
                  <jw-space v-else-if="item.status === '2'" class="stage-content-finished">
                    <icon-check-circle />
                    <span>{{ $t('已完成') }}</span>
                  </jw-space>
                </div>
                <div class="stage-content-text">
                  <jw-space direction="vertical" fill>
                    <div class="stage-content-title">
                      <span class="stage-content-title-span">{{ item.name }}</span>
                      <jw-button size="small" v-if="item.status === '0'" disabled class="stage-content-title-button">{{ $t('完成') }}</jw-button>
                      <jw-button type="primary" size="small" :disabled="lockedStatusOrigin" v-else-if="item.status === '1' && !data.doneButton && hasPermission" @click="finishDoneTask(item, levelIndex)" class="stage-content-title-button" :loading="activeButtonIndex === levelIndex && doneTaskLoading">{{ $t('完成') }}</jw-button>
                    </div>
                    <template v-if="item.conditions === 0">
                      <div class="stage-content-descripe" title="">{{ item.memo }}</div>
                    </template>
                    <template v-else-if="item.conditions === 1">
                      <div direction="vertical" fill v-for="(k, levelIndex2) in item.taskDetails" :key="k.id">
                        <div class="stage-content-task-item">
                          <span :style="{ width: '120px' }">{{ k.label }}：</span>
                          <div class="stage-content-task-value">
                            <div v-for="(label, index) in k.fieldValues" :key="label + index" class="stage-content-task-value-intended-effect">
                              <!-- <jw-input-number v-if="k.fieldType === 7"placeholder="请输入" model-event="input" :precision="2" allow-clear :min="0" v-model="label.value" class="stage-content-task-input"  :disabled="item.status !== '1' || data.doneButton || !hasPermission" :class="{ 'form-bgc-color': label.activedInput && !label.value }" @blur="changeEffect(item,k.id)" /> -->

                              <!-- 单行文本 -->
                              <jw-input v-if="k.fieldType === 0 || k.fieldType === 11" v-model="label.value" :placeholder="`${$t('请输入')}${k.label}`" class="stage-content-task-input" :disabled="lockedStatusOrigin || item.status !== '1' || data.doneButton || !hasPermission" :style="{ maxWidth: '300px', width: '97%' }" :class="{ 'form-bgc-color': label.activedInput && !label.value }" @blur="changeEffect(levelIndex, k.id)" />
                              <!-- 多行文本 -->
                              <jw-textarea
                                v-else-if="k.fieldType == 1"
                                :placeholder="`${$t('请输入')}${k.label}`"
                                v-model="label.value"
                                :auto-size="{
                                  minRows: 2,
                                  maxRows: 5
                                }"
                                class="stage-content-task-input"
                                :style="{ maxWidth: '300px', width: '97%' }"
                                :disabled="lockedStatusOrigin || item.status !== '1' || data.doneButton || !hasPermission"
                                :class="{ 'form-bgc-color': label.activedInput && !label.value }"
                                @blur="changeEffect(levelIndex, k.id)"
                              />
                              <!-- 单选按钮 -->
                              <jw-radio-group v-else-if="k.fieldType == 2" class="stage-content-task-input" v-model="label.value" :disabled="lockedStatusOrigin || item.status !== '1' || data.doneButton || !hasPermission" :style="{ maxWidth: '300px', width: '97%' }" :class="{ 'form-bgc-color': label.activedInput && !label.value }" @change="changeEffect(levelIndex, k.id)">
                                <jw-radio v-for="radio in JSON.parse(k.fieldExt)" :key="radio.value" :value="radio.value">{{ radio.label }}</jw-radio>
                              </jw-radio-group>
                              <!-- 多选按钮 -->
                              <jw-checkbox-group v-else-if="k.fieldType == 3" class="stage-content-task-input" v-model="label.value" :disabled="lockedStatusOrigin || item.status !== '1' || data.doneButton || !hasPermission" :style="{ maxWidth: '300px', width: '97%' }" :class="{ 'form-bgc-color': label.activedInput && !label.value }" @change="changeEffect(levelIndex, k.id)">
                                <jw-checkbox v-for="box in JSON.parse(k.fieldExt)" :key="box.value" :value="box.value">{{ box.label }}</jw-checkbox>
                              </jw-checkbox-group>
                              <!-- 下拉单选 -->
                              <jw-select v-else-if="k.fieldType === 4" v-model="label.value" :placeholder="`${$t('请选择')}${k.label}`" class="stage-content-task-input" :options="JSON.parse(k.fieldExt)" popup-container=".stage-content-task-value-intended-effect" allow-clear allow-search :disabled="lockedStatusOrigin || item.status !== '1' || data.doneButton || !hasPermission" :style="{ maxWidth: '300px', width: '97%' }" :class="{ 'form-bgc-color': label.activedInput && !label.value }" @change="changeEffect(levelIndex, k.id)"> </jw-select>
                              <!-- 下拉多选 -->
                              <jw-select v-else-if="k.fieldType === 5" :placeholder="`${$t('请选择')}${k.label}`" multiple class="stage-content-task-input" v-model="label.value" :options="JSON.parse(k.fieldExt)" popup-container=".stage-content-task-value-intended-effect" :disabled="lockedStatusOrigin || item.status !== '1' || data.doneButton || !hasPermission" :style="{ maxWidth: '300px', width: '97%' }" :class="{ 'form-bgc-color': label.activedInput && !label.value }" @change="changeEffect(levelIndex, k.id)" allow-clear allow-search> </jw-select>
                              <!-- 人员选择是一个单框与角色权限中的添加人员一样 -->
                              <xl-tree-member-modal v-else-if="k.fieldType === 6 && !(item.status !== '1' || data.doneButton || !hasPermission)" ref="xlTreeMember" :tree="tree" @cb="getDeptUser($event, `${index}.fieldValue`, levelIndex, levelIndex2, 'user')" :user="label?.userValue" :style="{ maxWidth: '300px', width: '97%' }" :class="{ 'form-bgc-color': label.activedInput && !label.value }" @change="changeEffect(levelIndex, k.id)" :memberNumber="1" :multipleDep="tools.isJSON(k?.fieldExt) ? (JSON.parse(k?.fieldExt)?.single == 1 ? false : true) : true">
                                <jw-tooltip :content="label.userList?.join()" position="tl">
                                  <jw-input-tag v-model="label.userList" :style="{ maxWidth: '300px', width: '97%' }" :max-tag-count="3" readonly :placeholder="`${$t('请选择')}${k.label}`" />
                                </jw-tooltip>
                              </xl-tree-member-modal>
                              <template v-else-if="k.fieldType === 6 && (item.status !== '1' || data.doneButton || !hasPermission)">
                                <jw-tooltip :content="label.userList?.join()" position="tl">
                                  <jw-input-tag v-model="label.userList" :style="{ maxWidth: '300px', width: '97%' }" :max-tag-count="3" :placeholder="`${$t('请选择')}${k.label}`" :disabled="item.status !== '1' || data.doneButton || !hasPermission" />
                                </jw-tooltip>
                              </template>
                              <!-- 数字 此处会根据接口fieldExt返回的数据：例如：0,1,2,3,(100)%等等判断数字的精度 -->
                              <template v-else-if="k.fieldType === 7">
                                <jw-input-number v-if="JSON.parse(k.fieldExt).numberFormat === '100'" v-model="label.value" class="stage-content-task-input" :placeholder="`${$t('请选择')}${k.label}`" :min="0" allow-clear hide-button :disabled="lockedStatusOrigin || item.status !== '1' || data.doneButton || !hasPermission" :style="{ maxWidth: '300px', width: '97%' }" :class="{ 'form-bgc-color': label.activedInput && !(label.value || label.value == 0) }" @blur="changeEffect(levelIndex, k.id)">
                                  <template #append> % </template>
                                </jw-input-number>
                                <jw-input-number v-else-if="JSON.parse(k.fieldExt)?.numberUnit" class="stage-content-task-input" v-model="label.value" :placeholder="`${$t('请选择')}${k.label}`" :min="0" :precision="Number(JSON.parse(k.fieldExt).numberFormat)" :disabled="lockedStatusOrigin || item.status !== '1' || data.doneButton || !hasPermission" :style="{ maxWidth: '300px', width: '97%' }" :class="{ 'form-bgc-color': label.activedInput && !(label.value || label.value == 0) }" @blur="changeEffect(levelIndex, k.id)">
                                  <template #append> {{ JSON.parse(k.fieldExt)?.numberUnit || '' }} </template>
                                </jw-input-number>
                                <jw-input-number v-else class="stage-content-task-input" v-model="label.value" :placeholder="`${$t('请选择')}${k.label}`" :min="0" :precision="Number(JSON.parse(k.fieldExt).numberFormat)" :disabled="lockedStatusOrigin || item.status !== '1' || data.doneButton || !hasPermission" :style="{ maxWidth: '300px', width: '97%' }" :class="{ 'form-bgc-color': label.activedInput && !(label.value || label.value == 0) }" @blur="changeEffect(levelIndex, k.id)" />
                              </template>
                              <!-- 日期格式 -->
                              <jw-date-picker v-else-if="k.fieldType === 8" :show-time="isShowTime(k.fieldExt)" v-model="label.value" :placeholder="`${$t('请选择')}${k.label}`" class="stage-content-task-input" :format="k.fieldExt" :value-format="isShowTime(k?.fieldExt) ? 'YYYY-MM-DD HH:mm:00' : 'YYYY-MM-DD'" popup-container=".stage-content-task-value-intended-effect" position="br" :disabled="lockedStatusOrigin || item.status !== '1' || data.doneButton || !hasPermission" :style="{ maxWidth: '300px', width: '97%' }" :class="{ 'form-bgc-color': label.activedInput && !label.value }" @change="changeEffect(levelIndex, k.id)" />
                              <!-- 日期范围 -->
                              <template v-else-if="k.fieldType === 9">
                                <jw-range-picker v-if="k.fieldExt === '0'" v-model="label.value" class="stage-content-task-input" popup-container=".stage-content-task-value-intended-effect" :disabled="lockedStatusOrigin || item.status !== '1' || data.doneButton || !hasPermission" :style="{ maxWidth: '300px', width: '97%' }" :class="{ 'form-bgc-color': label.activedInput && !label.value }" @select="changeEffect(levelIndex, k.id)" />
                                <jw-range-picker v-else-if="k.fieldExt === '1'" class="stage-content-task-input" v-model="label.value" :disabledDate="(current) => dayjs(current).isAfter(dayjs())" popup-container=".stage-content-task-value-intended-effect" :disabled="lockedStatusOrigin || item.status !== '1' || data.doneButton || !hasPermission" :style="{ maxWidth: '300px', width: '97%' }" :class="{ 'form-bgc-color': label.activedInput && !label.value }" @select="changeEffect(levelIndex, k.id)" />
                                <jw-range-picker v-else v-model="label.value" class="stage-content-task-input" :disabledDate="(current) => dayjs(current).isBefore(dayjs(new Date().getTime() - 24 * 60 * 60 * 1000))" popup-container=".stage-content-task-value-intended-effect" :disabled="lockedStatusOrigin || item.status !== '1' || data.doneButton || !hasPermission" :style="{ maxWidth: '300px', width: '97%' }" :class="{ 'form-bgc-color': label.activedInput && !label.value }" @select="changeEffect(levelIndex, k.id)" />
                              </template>
                              <!-- 级联选择器 -->
                              <jw-cascader v-else-if="k.fieldType === 10" :options="JSON.parse(k.fieldExt)" :placeholder="`${$t('请选择')}${k.label}`" class="stage-content-task-input" v-model="label.value" path-mode allow-clear allow-search :disabled="lockedStatusOrigin || item.status !== '1' || data.doneButton || !hasPermission" :style="{ maxWidth: '300px', width: '97%' }" :class="{ 'form-bgc-color': label.activedInput && !label.value }" @change="changeEffect(levelIndex, k.id)" popup-container=".stage-content-task-value-intended-effect" />
                              <!-- 12查找关联--单选 -->
                              <div v-else-if="k.fieldType === 12" :style="{ maxWidth: '300px', width: '97%' }">
                                <xl-association :basic-data="{ id: data.id, entity: data.type, fieldKey: k?.value, relation: k?.fieldExt, fieldValueName: label?.fieldValueName }" :form-data="{}" v-model="label.value" :disabled="lockedStatusOrigin || item.status !== '1' || data.doneButton || !hasPermission" @change="changeEffect(levelIndex, k.id)" />
                              </div>
                              <!--25 查找关联多选  -->
                              <div v-else-if="k.fieldType === 25" :style="{ maxWidth: '300px', width: '97%' }">
                                <xl-association :multiple="true" :basic-data="{ id: data.id, entity: data.type, fieldKey: k?.value, relation: k?.fieldExt, fieldValueName: label?.fieldValueName }" :form-data="{}" v-model="label.value" :disabled="lockedStatusOrigin || item.status !== '1' || data.doneButton || !hasPermission" @change="changeEffect(levelIndex, k.id)" />
                              </div>
                              <!-- 附件 -->
                              <template v-else-if="k.fieldType === 18">
                                <fh-attachment-upload :fieldExt="k?.fieldExt" :disabled="lockedStatusOrigin || item.status !== '1' || data.doneButton || !hasPermission" v-model="label.value" :showRemoveBtn="!(item.status !== '1' || data.doneButton || !hasPermission)" @cb="getFiles($event, `${index}.fieldValue`, levelIndex, levelIndex2)" :defaultFileList="label.value" class="stage-content-task-input" />
                              </template>
                              <!--22 部门 -->
                              <xl-tree-member-modal v-else-if="k?.fieldType === 22 && !(item.status !== '1' || data.doneButton || !hasPermission)" ref="xlTreeMember" :tree="departTree" @cb="getDeptUser($event, `${index}.fieldValue`, levelIndex, levelIndex2, 'dept')" :multipleDep="k?.fieldExt == 1 ? false : true" :depart="label?.departValue" :style="{ maxWidth: '300px', width: '97%' }" :class="{ 'form-bgc-color': label.activedInput && !label.value }">
                                <!-- {{ label }} -->
                                <jw-input-tag v-model="label.departList" :style="{ maxWidth: '300px', width: '97%' }" :disabled="lockedStatusOrigin" :max-tag-count="3" readonly :placeholder="`${$t('请选择')}${k.label}`" />
                              </xl-tree-member-modal>
                              <jw-input-tag v-else-if="k.fieldType === 22 && (item.status !== '1' || data.doneButton || !hasPermission)" v-model="label.departList" :style="{ maxWidth: '300px', width: '97%' }" :max-tag-count="1" :placeholder="`${$t('请选择')}${k.label}`" :disabled="lockedStatusOrigin || item.status !== '1' || data.doneButton || !hasPermission" />
                              <!-- 23百分比 -->
                              <jw-input-number v-else-if="k?.fieldType === 23" v-model="label.value" class="stage-content-task-input" :placeholder="`${$t('请选择')}${k.label}`" :min="0" :precision="Number(JSON.parse(k.fieldExt).numberFormat)" allow-clear :disabled="lockedStatusOrigin || item.status !== '1' || data.doneButton || !hasPermission" :style="{ maxWidth: '300px', width: '97%' }" :class="{ 'form-bgc-color': label.activedInput && !(label.value || label.value == 0) }" @blur="changeEffect(levelIndex, k.id)">
                                <template #append> % </template>
                              </jw-input-number>
                              <!-- 计算类型字段 -->
                              <!-- 数字（汇总累计) 金额（汇总累计) -->
                              <!-- <template v-else-if="k.fieldType === 24">
                                <jw-input v-model="label.value" placeholder="计算字段" disabled class="stage-content-task-input" :style="{ maxWidth:'300px',width:'97%' }" />
                              </template> -->
                              <!-- 24计算类型 -->
                              <template v-else-if="k?.fieldType === 24">
                                <!-- 6:金额（汇总累计) 16:金额 -->
                                <template v-if="k.fieldExt?.type === 6 || k.fieldExt?.type === 16">
                                  <jw-input-number disabled class="stage-content-task-input" v-model="label.value" placeholder="计算字段" :precision="Number(k?.fieldExt?.dataType)" />
                                </template>
                                <!-- 23：百分比 -->
                                <template v-else-if="k.fieldExt?.type === 23">
                                  <jw-input-number v-model="label.value" class="stage-content-task-input" placeholder="计算字段" hide-button disabled :precision="Number(k?.fieldExt?.dataType)">
                                    <template #append> % </template>
                                  </jw-input-number>
                                </template>
                                <!-- 5:数字（汇总累计) 7:数字  -->
                                <template v-else-if="k.fieldExt?.type == 5 || k.fieldExt?.type == 7">
                                  <jw-input class="stage-content-task-input" v-model="label.value" placeholder="计算字段" disabled :precision="Number(k?.fieldExt?.dataType)" />
                                </template>
                                <!-- 8:日期-->
                                <template v-else-if="k.fieldExt?.type === 8">
                                  <jw-date-picker v-if="k.fieldExt.dataType == 'YYYY/MM/DD HH:mm' || k.fieldExt.dataType == 'YYYY-MM-DD HH:mm'" v-model="label.value" placeholder="计算字段" show-time class="stage-content-task-input" :format="k.fieldExt.dataType" position="br" disabled value-format="YYYY-MM-DD HH:mm:00" />
                                  <jw-date-picker v-else v-model="label.value" placeholder="计算字段" class="stage-content-task-input" :format="k.fieldExt.dataType" position="br" disabled value-format="YYYY-MM-DD" />
                                </template>
                                <jw-input v-else disabled class="stage-content-task-input" v-model="label.value" placeholder="计算字段" />
                              </template>
                              <w-editor v-else-if="k?.fieldType === 26" v-model="label.value" :configs="{ editorConfig: { placeholder: `${$t('请输入')}${k.label}`, readOnly: lockedStatusOrigin || item.status !== '1' || data.doneButton || !hasPermission } }"></w-editor>
                              <!-- 其他类型 -->
                              <jw-input v-else :style="{ maxWidth: '300px', width: '97%' }" placeholder="请输入" allow-clear v-model="label.value" class="stage-content-task-input" :disabled="lockedStatusOrigin || item.status !== '1' || data.doneButton || !hasPermission" :class="{ 'form-bgc-color': label.activedInput && !label.value }" @blur="changeEffect(levelIndex, k.id)" />
                              <!-- 效验 -->
                              <div class="intended-effect-text" v-if="label.activedInput && !(label.value && label.value?.length) && k.fieldType !== 24 && ![7, 16, 23].includes(k.fieldType)">
                                {{ k.label + $t('是必填项') }}
                              </div>
                              <div class="intended-effect-text" v-if="label.activedInput && !(label.value || label.value === 0) && k.fieldType !== 24 && [7, 16, 23].includes(k.fieldType)">
                                {{ k.label + $t('是必填项') }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </template>
                    <template v-else-if="item.conditions === 2">
                      <div direction="vertical" fill v-for="k in item.taskDetails" :key="k.id">
                        <div class="stage-content-task-item stage-content-task-doc">
                          <span class="stage-content-task-label">{{ k.label }}：</span>
                          <jw-radio-group class="stage-content-task-group" :default-value="1" v-model="k.type" :disabled="lockedStatusOrigin || item.status !== '1' || data.doneButton || !hasPermission" @change="radioGroupChange(k)">
                            <jw-radio :value="1"> {{ $t('云文档') }} </jw-radio>
                            <jw-radio :value="2">{{ $t('本地附件') }}</jw-radio>
                          </jw-radio-group>
                          <div class="stage-content-task-value">
                            <div v-for="(label, index) in k.fieldValues" :key="label + index" class="stage-content-task-value-intended-effect">
                              <div class="stage-content-task-value-all" v-if="k.type === 1 && item.status === '1'">
                                <jw-input :style="{ width: '260px' }" class="stage-content-task-input" placeholder="请输入" v-model.trim="label.value" allow-clear :class="{ 'form-bgc-color': index === 0 && label.activedInput && !label.value }" @blur="changeEffect(levelIndex, k.id)" :disabled="lockedStatusOrigin || data.doneButton || !hasPermission" />
                                <jw-space>
                                  <icon-plus-circle v-if="item.status === '1' && !data.doneButton && hasPermission" size="20" class="hand" @click="addTask(k.id)" />
                                  <icon-minus-circle size="20" v-if="k.fieldValues.length > 1 && item.status === '1' && hasPermission" @click="removeTask(k.id, index)" class="hand" />
                                </jw-space>
                              </div>
                              <div class="stage-content-task-link" v-else>
                                <template v-if="k.type === 1">
                                  <jw-link :title="label?.label || label?.value" v-if="!label.deleted" :href="label.value" target="_blank">{{ label?.business || label.value }}</jw-link>
                                  <jw-link v-else :class="{ 'text-delete-through-line': label.deleted }" title="该文件已删除">{{ label?.business || label.value }}</jw-link>
                                </template>
                                <template v-if="k.type === 2 && item.status === '2'">
                                  <jw-link :title="label.business" v-if="!label.deleted" :href="label.value" target="_blank">{{ label?.business || label.value }}</jw-link>
                                  <jw-link v-else :class="{ 'text-delete-through-line': label.deleted }" title="该文件已删除">{{ label?.business || label.value }}</jw-link>
                                </template>
                              </div>
                              <div class="intended-effect-text" v-if="index === 0 && label.activedInput && !label.value">
                                <span v-if="k.type === 1">{{ $t('请输入') }}{{ k.label }}</span>
                                <span v-else>{{ $t('请点击上传本地附件') }}</span>
                              </div>
                            </div>
                            <div v-if="k.type === 2 && item.status === '1'">
                              <jw-upload :action="data.url" draggable tip="文件类型无限制" :headers="data.headers" @success="uploadSuccess($event, k)" :show-retry-button="false" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </template>
                    <template v-else-if="item.conditions === 3">
                      <div class="stage-content-approve" v-if="item.status == 0">
                        <jw-button disabled class="approve-btn">发起审批</jw-button>
                        <!--<jw-button disabled type="primary">完成</jw-button>-->
                      </div>
                      <div class="stage-content-approve" v-else-if="item.status == 1">
                        <div style="display: flex; align-items: center">
                          <jw-button v-if="!item.approveInfo?.approveStatus" :disabled="lockedStatusOrigin" class="approve-btn" @click="toggleApprove(item)">发起审批</jw-button>
                          <template v-else-if="item.approveInfo?.approveStatus && item.approveInfo?.approveStatus == 'PENDING'">
                            <span style="color: #ffb400; cursor: pointer" :disabled="lockedStatusOrigin" @click="toApprove(item)">审批中<icon-caret-right /></span>
                          </template>
                          <template v-else-if="item.approveInfo?.approveStatus && item.approveInfo?.approveStatus == 'APPROVED'">
                            <span @click="toApprove(item)" style="cursor: pointer" :disabled="lockedStatusOrigin">同意<icon-caret-right /></span>
                          </template>
                          <template v-else>
                            <div @click="toApprove(item)" style="cursor: pointer" :disabled="lockedStatusOrigin">
                              <span class="refuse-btn">拒绝<icon-caret-right /></span>
                            </div>
                            <jw-button class="approve-btn" @click="toggleApprove(item)" :disabled="lockedStatusOrigin">重新发起审批</jw-button>
                          </template>
                        </div>
                      </div>
                      <div class="stage-content-approve" v-else-if="item.status == 2">
                        <div style="display: flex; align-items: center">
                          <div :disabled="lockedStatusOrigin" @click="toApprove(item)">
                            <span class="refuse-btn"> {{ item?.approveInfo?.approveStatus == 'PENDING' ? '审批中' : item.approveInfo?.approveStatus == 'APPROVED' ? '同意' : '拒绝' }} </span><icon-caret-right />
                          </div>
                          <jw-button v-if="item?.approveInfo?.approveStatus == 'REJECTED'" class="approve-btn" :disabled="lockedStatusOrigin" @click="toggleApprove(item)">重新发起审批</jw-button>
                        </div>
                      </div>
                    </template>
                    <template v-else-if="item.conditions === 4">
                      <div class="stage-content-task-item">
                        <span :style="{ width: '120px' }">{{ $t('客户') }}：</span>
                        <div class="stage-content-task-value">
                          <span style="margin-top: -5px">{{ item.taskDetails[0]?.fieldValues[0]?.label || '-' }} </span>
                          <jw-tooltip v-if="!item.taskDetails[0]?.fieldValues[0]?.label" :content="$t('tips.bussinessCustomer')" position="top" mini>
                            <icon-exclamation-circle-fill size="20" style="color: orange; cursor: pointer" @click="correlation(item)" />
                          </jw-tooltip>
                          <div class="busineShow">
                            <jw-tooltip :content="item.taskDetails[0]?.fieldValues[0]?.business ? $t('查看工商信息') : $t('tips.customerIsRequired')" position="top" mini>
                              <span @click="busineShow(item)">
                                <qf-icon-business width="20px" height="20px" :color="item.taskDetails[0]?.fieldValues[0]?.business ? 'rgb(var(--primary-6))' : '#C9CDD4'" style="margin-left: 10px; cursor: pointer" />
                              </span>
                              <template v-if="lockedStatusOrigin || item.status !== '1' || data.doneButton || !hasPermission">
                                <span style="margin-top: -5px; color: var(--color-text-4); cursor: no-drop">{{ $t('关联工商信息') }}</span>
                              </template>
                              <template v-else>
                                <span @click="busineOpp(item)" style="margin-top: -5px; color: rgb(var(--primary-6)); cursor: pointer">{{ $t('关联工商信息') }}</span>
                              </template>
                            </jw-tooltip>
                          </div>
                        </div>
                      </div>
                    </template>
                  </jw-space>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </jw-card>
    <jw-modal v-model:visible="data.visible" :title="data.form.title" width="500px" @cancel="handleCancelStage" @ok="handleOk" title-align="start" auto-label-width>
      <div style="margin-bottom: 10px">{{ $t('回退后，若已完成的阶段内有审批任务，需要重新提交审批') }}</div>
      <jw-form label-align="left" :model="data.form" ref="formRef" @submit="handleSubmit" class="form-reason">
        <jw-form-item field="reason" :rules="{ required: true, message: data.form.placeholder }" :validate-trigger="['blur', 'change']" :label="$t('原因')" :label-col-style="{ width: '100px' }" show-colon label-col-flex="auto">
          <jw-textarea
            :placeholder="data.form.placeholder"
            v-model="data.form.reason"
            :auto-size="{
              minRows: 2,
              maxRows: 5
            }"
            class="card-form-item-value"
          />
        </jw-form-item>
      </jw-form>
    </jw-modal>
    <!-- <jw-modal v-model:visible="data.successVisible" @ok="successHandleOk" @cancel="handleCancel" title="赢单确认" title-align="start">
        <div>请确认是否已赢单？确认后将不可回退</div>
      </jw-modal> -->
    <jw-modal v-model:visible="data.stageVisible" @ok="stageHandleOk" @cancel="handleCancel" :title="$t('当前阶段任务已全部完成')" :ok-text="$t('推进至下一阶段')" :cancel-text="$t('暂不')" title-align="start">
      <div>{{ $t('tips.nextConfirm') }}</div>
    </jw-modal>
  </div>
  <div class="page-comp-opportunity-stage" v-else>
    <jw-card :bordered="false">
      <div class="stage-title">
        <span class="title">{{ $t('商机阶段') }}</span>
      </div>
      <div class="stage-empty">{{ $t('暂无配置') }}</div>
    </jw-card>
  </div>
  <jw-modal title="发起审批" :ok-loading="isApproveLoading" :visible="isSubApprove" @ok="approveHandleSubmit" @cancel="isSubApprove = false">
    <jw-form :model="data.approveForm" ref="approveFormRef" @submit="approveSubmit" class="form-reason">
      <template v-for="field in approveFields" :key="field.id">
        <jw-form-item v-if="field.value && field.label" class="form-label-text" :field="field.value" :rules="{ required: field?.required, message: `${$t('请输入')}${field.label}` }" :label-col-style="{ width: '150px' }" label-col-flex="auto">
          <template #label>
            <xl-label-text :value="field.label" :row="1" width="90px" />
          </template>
          <xl-field :id="data.id" :entity="data.type" @cb="getApproveValue" :field="field" />
        </jw-form-item>
      </template>
    </jw-form>
  </jw-modal>
  <!-- 关联客户 -->
  <xl-band-customer ref="customerRef" @cb="addCustomer"></xl-band-customer>
  <!-- 关联工商信息 -->
  <xl-business-information ref="informationRef" @cb="loadTList"></xl-business-information>
  <!-- 展示关联的工商信息 -->
  <xl-business-message ref="businessmessageRef"></xl-business-message>
</template>

<script setup>
import { reactive, inject, ref, computed, provide } from 'vue';
import { Message } from '@arco-design/web-vue';
import xlField from '@/components/xl-field/xl-field.vue';
import { opportunityService } from '@/api/';
import { getToken } from '@/utils/auth';
import { tools } from '@/utils/tools';
import { useI18n } from 'vue-i18n';
import dayjs from 'dayjs';
const props = defineProps({
  detailAllFields: {
    type: Object,
    default() {
      return {};
    }
  }
});

//  锁定状态 + 生命状态
const lockedStatusOrigin = computed(() => {
  if (props.detailAllFields?.locked === true) {
    return true;
  } else {
    if (props.detailAllFields.status == 1 || props.detailAllFields.status == 6) {
      return true;
    } else {
      return false;
    }
  }
});

const token = getToken() || null;
const formRef = ref();
const approveFormRef = ref();
const businessmessageRef = ref(); //展示工商信息
const informationRef = ref(); //关联工商信息
const customerRef = ref(); //关联客户
const emit = defineEmits(['cb']);
const { t } = useI18n();
const approveFields = ref([]);
const approveTaskId = ref(null);
const isSubApprove = ref(false);
const isApproveLoading = ref(false);
const initFresh = ref(true); //
const data = reactive({
  endStatus: { label: '结束', winRate: '', status: '0' },
  // endStage: false,
  recordValue: '',
  addClass: null,
  addClassIndex: null,
  unfold: false,
  id: inject('detailParams').id, //商机id,
  type: inject('detailParams').entity,
  penultStage: '', //阶段倒数第二项的value值
  permission: inject('detailParams')?.permission, //权限
  detailAllFields: inject('detailParams')?.detailAllFields, //权限
  title: '',
  captainList: [], //车队长下拉值
  url: '/api/upload',
  headers: {
    authorization: `Bearer ${token}`
  },
  lastIndex: null,
  fileString: '',
  stageId: '',
  stageProcess: '',
  disabledUpload: false,
  visible: false,
  // successVisible: false,
  stageVisible: false,
  isPerformance: [],
  approveForm: {},
  form: {
    reason: '',
    placeholder: '',
    title: ''
  },
  allDetail: {},
  boostStage: '', //推进或回退阶段
  currentStage: '', //当前阶段
  showWinRate: false,
  doneButton: false, //结束路线上的按钮和输入框是否展示
  tasks: [], //任务列表
  boost: null,
  currentReadio: '1',
  detailsId: null,
  radioGroup: null,
  currentObj: {},
  // opStageList: [], //全部阶段
  progressStage: [], //进行中阶段
  finalStage: [], //终极阶段
  finalStageValue: [], //终极阶段的value值数组集合
  endList: {},
  isFinishStage: null, //是否没有中级阶段-1代表没有
  isLastShow: false, //最后一个阶段时，是否展示推进至下一阶段
  noCancel: true, //终极状态取消时背景色控制
  customerId: null,
  updateData: inject('detailParams').updateData,
  opLoading: true
});
const hasPermission = computed(() => data.permission == 1 && data.endList?.value != '60' && data.endList?.value != '70' && data.endList?.value != '80');
//展示关联工商
const busineShow = (v) => {
  businessmessageRef.value?.messageShow(v.taskDetails[0]?.fieldValues[0]?.value);
};
// 是否展示时间
const isShowTime = (ext) => {
  // const ext = item?.fieldType != 21 ? data.objList?.fieldExt : data.objList?.business?.fieldExt;
  if (!ext) return false;
  if (ext?.includes('HH:mm') || ext?.includes('HH:mm:ss') || ext?.includes('hh:mm')) {
    return true;
  } else {
    return false;
  }
};
const toApprove = (item) => {
  window.open(item?.approveInfo?.approveUrl, '_blank');
};
provide('defaultParams', {
  id: computed(() => data.customerId)
});
const toggleApprove = (item) => {
  approveFormRef.value.resetFields();
  data.approveForm = {};
  console.log(data.updateData);
  console.log(item, '###');
  item?.taskDetails.map((itd) => {
    if (data.updateData && data.updateData.length > 0) {
      let _value = null;
      if (itd?.fieldValues && itd?.fieldValues.length > 0) {
        if (tools.isJSON(itd?.fieldValues?.[0]?.value)) {
          _value = !Array.isArray(JSON.parse(itd?.fieldValues?.[0]?.value)) ? [JSON.parse(itd?.fieldValues?.[0]?.value)] : JSON.parse(itd?.fieldValues?.[0]?.value);
        } else {
          _value = itd?.fieldValues?.[0]?.value;
        }
      } else {
        data.updateData.map((du) => {
          if (du?.modules && du?.modules?.length > 0) {
            du?.modules.map((dum) => {
              if (dum?.type == 20) {
                if (dum.value == itd.value) {
                  _value = dum.fieldValue;
                }
              }
            });
          }
        });
      }

      data.approveForm[itd.value] = _value;
      if (itd.fieldType == 22) {
        if (Array.isArray(_value)) {
          _value.map((v) => {
            v['departmentName'] = v.name;
          });
        }
        itd['fv'] = {
          departList: _value || []
        };
        itd.fieldValue = _value ? _value?.map((v) => v.name) : [];
      } else if (itd?.fieldType == 24) {
        console.log(470, itd, _value, itd.fieldExt);
        if (itd?.fieldExt) {
          // itd.fieldExt = JSON.parse(itd?.fieldExt);
          // if (itd?.fieldExt?.type == 6 || itd?.fieldExt?.type == 16) {
          //   //6：汇总金额 16：金额
          //   itd.fieldValues[0].value = itd.fieldValues?.[0]?.value ? tools.getPrice(itd.fieldValues[0].value) : '';
          // } else if (itd?.fieldExt?.type == 23) {
          //   //百分比
          //   itd.fieldValues[0].value = itd.fieldValues?.[0]?.value ? tools.getPercentage(itd.fieldValues?.[0]?.value, itd?.fieldExt?.dataType) : '';
          // } else if (itd?.fieldExt?.type == 5 || itd?.fieldExt?.type == 7) {
          //   itd.fieldValues[0].value = !isNaN(parseFloat(itd.fieldValues[0].value)) ? parseFloat(itd.fieldValues[0].value).toFixed(itd?.fieldExt?.dataType) : '';
          // } else {
          //   itd.fieldValues[0].value = itd.fieldValues?.[0]?.value ? itd.fieldValues[0].value : '';
          // }
          itd.fieldValue = itd.fieldValues?.[0]?.value ? itd.fieldValues[0].value : '';
        }
      } else if (itd.fieldType == 6) {
        if (Array.isArray(_value)) {
          _value.map((v) => {
            v['userName'] = v.name;
            v['avatarOrigin'] = v.avatar;
          });
        }
        itd['fv'] = {
          userList: _value || []
        };
        itd.fieldValue = _value ? _value?.map((v) => v.name) : [];
      } else {
        itd.fieldValue = _value;
      }
    }
  });

  approveFields.value = item?.taskDetails;
  approveTaskId.value = item?.id;
  isSubApprove.value = true;
};
const getApproveValue = (fieldValue) => {
  data.approveForm[fieldValue.value] = fieldValue.fieldValue;
  approveFormRef.value.validateField(fieldValue.value);
};
const approveHandleSubmit = () => {
  approveFormRef.value.handleSubmit();
};
const approveSubmit = ({ values, errors }) => {
  if (!errors) {
    isApproveLoading.value = true;
    const approveData = {
      id: data.detailsId,
      taskId: approveTaskId.value,
      fieldAndValueVos: []
    };
    approveFields.value.map((afv) => {
      if (afv?.label && afv?.value) {
        let _value = [];
        if (afv?.fieldType == 6) {
          _value = [afv?.fv?.userList?.[0]?.id];
        } else if (afv?.fieldType == 9) {
          if (afv.fieldValue && afv.fieldValue.length > 0) {
            _value = [
              JSON.stringify({
                beginDate: afv.fieldValue?.[0] ?? '',
                endDate: afv.fieldValue?.[1] ?? ''
              })
            ];
          }
        } else if (afv?.fieldType == 10) {
          _value = afv.fieldValue ? [afv.fieldValue?.join('/')] : [];
        } else if (afv?.fieldType == 22) {
          _value = afv?.fv?.departList?.[0]?.id ? [afv?.fv?.departList?.[0]?.id] : [];
        } else if (afv?.fieldType == 16) {
          _value = afv?.fieldValue ? [tools.setPrice(values?.[afv.value])] : [];
        } else if (afv?.fieldType == 23) {
          console.log(521, afv);
          _value = afv?.fieldValue ? [tools.setPercentage(values?.[afv.value], tools.isJSON(afv.fieldExt) && JSON.parse(afv.fieldExt)?.numberFormat)] : [];
        } else if (afv?.fieldType == 18) {
          if (afv.fieldValue && afv.fieldValue.length > 0) {
            afv.fieldValue.map((afvf) => {
              _value.push(afvf);
            });
            _value = [JSON.stringify(_value)];
          }
        } else if (values?.[afv.value]) {
          if (typeof values?.[afv.value] == 'object') {
            _value = values?.[afv.value];
          } else {
            _value = [values?.[afv.value]];
          }
        }
        approveData.fieldAndValueVos.push({
          field: afv.value,
          fieldValues: _value,
          fieldType: afv.fieldType
        });
      }
    });

    doApproveSubmit(approveData);
  }
};
const doApproveSubmit = async (data) => {
  try {
    isApproveLoading.value = true;
    const res = await opportunityService.approveTask(data);
    if (!res.error) {
      Message.success(t('操作成功'));
      emit('cb');
    } else {
      Message.error(res.error?.msg || '操作失败');
    }
    isApproveLoading.value = false;
  } catch (err) {
    isApproveLoading.value = false;
    console.log(err);
  }
};
// 关联客户
const correlation = (record) => {
  console.log('33333', record);
  data.type = 3;
  record.taskDetails[0].fieldValues[0].value = data.customerId;
  const params = {
    type: data.type,
    isNotRelated: 1,
    customerName: record.taskDetails[0]?.fieldValues[0]?.label
  };
  customerRef.value.correlationOpen(params);
};
// 关联工商信息
const busineOpp = (item) => {
  if (!item.taskDetails[0]?.fieldValues[0]?.label || item.taskDetails[0]?.fieldValues[0]?.label == '') {
    Message.warning(t('tips.bussinessCustomer'));
    return;
  }
  informationRef.value.correlationOpen(item.taskDetails[0]?.fieldValues[0]?.label, 'index-list');
};
const addCustomer = async () => {
  await getEntityStage();
  await emit('cb');
};
//关联后
const loadTList = async (v) => {
  data.tasks.forEach((item) => {
    if (item.conditions === 4) {
      item.taskDetails[0].fieldValues[0].label = v.name;
      item.taskDetails[0].fieldValues[0].business = v.id;
    }
  });
  await emit('cb');
};
//查找关联多选格式化
const formatTasks4Association = (tasks) => {
  const ret = JSON.parse(JSON.stringify(tasks));
  ret.map((item) => {
    if (item?.taskDetails?.length > 0) {
      item?.taskDetails.map((tdv) => {
        if ((tdv?.fieldType == 12 || tdv?.fieldType == 25) && tdv?.fieldValues?.length > 0) {
          tdv?.fieldValues.map((tdvf) => {
            if (tdv?.fieldType == 12 && tdv?.value) {
              tdvf['fieldValueName'] = tdvf?.label;
            } else if (tdv?.fieldType == 25 && tdv?.value && tdv?.value?.length > 0) {
              tdvf['fieldValueName'] = tdvf?.value?.map((tdvfv) => tdvfv?.label);
              tdvf['value'] = tdvf?.value?.map((tdvfv) => tdvfv?.value);
            }
          });
        }
      });
    }
  });

  return ret;
};
const selectSteps = (record, index, status) => {
  if (!status) {
    data.addClass = index;
    data.detailsId = record.id;
    data.lastIndex = index;
    // 推进或回退阶段用的状态码
    data.boostStage = record.status;
    data.tasks = formatTasks4Association(record.tasks);
    // 推进或回退阶段
    data.stageProcess = record?.value;
    // if (['60', '70', '80'].indexOf(data.allDetail?.currentStage) === -1) {
    if (data.finalStageValue.indexOf(data.allDetail?.currentStage) > -1) {
      data.endStatus = { label: '结束', value: '', status: '0' };
    }
  } else {
    if (data.endStatus.label !== '结束') {
      data.addClass = index;
      // 推进或回退阶段用的状态码
      data.boostStage = record.status;
      data.tasks = formatTasks4Association(record.tasks);
    } else {
      data.addClassIndex = index;
    }
  }
};
//获取参与人列表
const getList = async () => {
  data.list = [];
  const params = {
    id: data.id,
    entity: data.type
  };
  try {
    const json = await opportunityService.getStageWeights(params);
    if (json.error) {
      Message.error(json.error?.msg || t('数据获取失败'));
      return false;
    }
    data.isPerformance = json.result;
  } catch (e) {
    console.log(e);
  }
};
// 获取文件列表
const getFiles = (files, props, levelIndex, levelIndex2) => {
  console.log(1080, files, props);
  // 获取files.response.data的值,不要双层数组
  const filesList = [];
  files &&
    files.length > 0 &&
    files?.forEach((v) => {
      if (v.response) {
        const url = v.response?.data;
        console.log(1081, ...url);
        filesList.push(...url);
      } else {
        filesList.push({ name: v.name, url: v.url });
      }
    });
  data.allDetail?.details?.forEach((item) => {
    console.log(981, item.tasks);
    // 如果初始化时tasks下的taskDetails下的fieldValues不为空
    item.tasks?.forEach((subItem, j) => {
      if (levelIndex === j) {
        subItem.taskDetails?.forEach((m, k) => {
          if (m.fieldType === 18 && levelIndex2 === k) {
            m.fieldValues.forEach((n) => {
              n.value = filesList;
            });
          }
        });
      }
    });
  });
  data.tasks[levelIndex]?.taskDetails?.forEach((m, k) => {
    if (m.fieldType === 18 && levelIndex2 === k) {
      m.fieldValues.forEach((n) => {
        n.value = filesList;
      });
    }
  });
  console.log('data.allDetail?.details--', data.allDetail);
  console.log(' data.tasks---', data.tasks);
  // data.allDetail.details.forEach((det) => {
  //   det?.tasks?.forEach((task) => {
  //     task.taskDetails.forEach((taskDet) => {
  //       if (taskDet.value === k.value && taskDet.fieldType == 18) {
  //         taskDet.fieldValues.forEach((item) => {
  //           console.log(685, item, k);
  //           // 判断字段是否相等，相等则赋值给taskDet.fieldValue
  //           item.value = filesList;
  //         });

  //         // filesList.forEach((file, index) => {
  //         //   if (taskDet.fieldValues[index]) {
  //         //     taskDet.fieldValues[index].value = file;
  //         //   } else {
  //         //     taskDet.fieldValues.push({ label: null, value: file, business: null, deleted: null, activedInput: false });
  //         //   }
  //         // });
  //       }
  //     });
  //   });
  // });
};
// 结束状态下拉选择
const handleSelect = (v, record) => {
  console.log(258, v, record);
  data.noCancel = false;
  data.endStatus = v;
  data.detailsId = v.id;
  // 推进或回退阶段
  data.stageProcess = v?.value;
  data.boostStage = '100'; //不等于0/1/2即可
  console.log(271, data.boostStage);
  data.tasks = formatTasks4Association(v.tasks);
  if (data.addClassIndex) {
    data.addClass = data.addClassIndex;
    console.log(235, data.addClass, data.addClassIndex);
  }
  stageEnd();
};
// 商机详情---商机阶段--阶段展示
const getEntityStage = async () => {
  // 初次加载loading
  if (initFresh.value) {
    data.opLoading = true;
  }

  try {
    const params = {
      id: data.id,
      entityType: data.type
    };
    const res = await opportunityService.getEntityStage(params);
    data.opLoading = false;
    console.log(130, res);
    const o = filterApproval(res?.result);

    if (!res.error && o) {
      initFresh.value = false;
      data.allDetail = o;
      data.title = o?.label;
      data.showWinRate = o?.showWinRate || false;
      data.boostStage = o?.details.find((v) => v.value === data.allDetail?.currentStage)?.status;
      // console.log(335, data.boostStage);
      // 根据currentstage找到当前这一条数据
      const boostCurrent = o?.details?.filter((item) => item.value === o?.currentStage);
      const arrStatus = boostCurrent?.[0]?.tasks?.map((i) => i.status);
      data.boost = arrStatus?.every((i) => i === '2');
      // console.log(264, data.boost);
      // 推进至下一阶段的参数id
      data.stageId = o?.id;
      // 初始化时存储所有数据
      // data.opStageList = o?.details;
      // 区分是否终极阶段
      const progressStage = [];
      const finalStage = [];
      o?.details?.forEach((item) => {
        if (item.ultimate) {
          finalStage.push(item);
        } else {
          progressStage.push(item);
        }
        if (item.ultimate && item.value === o?.currentStage) {
          progressStage.push(item);
        }
      });
      // 结束前的最后一项的value
      // 判断整个阶段流程中是否没有终极阶段
      const isFinishStage = o?.details?.findIndex((v) => v.ultimate);
      data.isFinishStage = isFinishStage;
      // console.log(358, isFinishStage);
      data.penultStage = progressStage?.[progressStage?.length - 1].value;
      // console.log(379, data.penultStage);
      // progressStage.push({ final: true, label: '结束' });
      data.finalStage = finalStage;
      // 结束状态的value值集合
      const finalStageValue = data.finalStage?.map((v) => v.value);
      data.finalStageValue = finalStageValue;
      const isShowFinish = finalStageValue?.indexOf(o?.currentStage) !== -1;
      if (!isShowFinish && finalStageValue.length > 0) {
        progressStage.push({ final: true, label: t('结束') });
      }
      data.progressStage = progressStage;
      // console.log(357, data.progressStage, isShowFinish, finalStageValue);
      if (data.isFinishStage !== -1) {
        // 如果有终极阶段倒数第二项不能有推进至下一阶段
        data.isLastShow = data.penultStage === o?.currentStage;
        // console.log(380, data.isLastShow, o?.currentStage);
      } else {
        // 如果没有终极阶段最后一项可以有推进至下一阶段
        data.isLastShow = o?.details[o?.details?.length - 1].value === o?.currentStage;
        // console.log(381, data.isLastShow, o?.currentStage, o?.details[o?.details?.length - 1].value);
      }
      // 操作数据--因为步骤条的第一步是从1开始递增的
      const list = o?.details?.map((i) => i.value);
      // 把数组变成一个对象
      const currentObj = {};
      list?.forEach((item, index) => {
        currentObj[item] = index + 1;
      });
      // 推进至下一阶段的参数stageProcess,当前阶段的下一阶段的value
      const sd = list?.findIndex((p) => p === o?.currentStage);
      data.stageProcess = list[sd];
      // console.log(295, sd, data.stageProcess);
      data.currentObj = currentObj; //生成步骤条激活项对象
      data.currentStage = String(currentObj[o?.currentStage]); //给步骤条初始化赋值
      data.lastIndex = data.currentStage - 1; //普通阶段的最后一个不展示推进至下一阶段
      // console.log(382, data.lastIndex);
      // data.boostStage = String(currentObj[o?.currentStage]); //推进下一阶段用的
      data.addClass = String(currentObj[o?.currentStage] - 1); //给激活想初始化赋值
      // console.log(123, data.currentObj, data.currentStage, data.boostStage);
      // console.log(178, list, currentObj);
      // 初始化选择激活状态时赋值任务列表
      o?.details?.forEach((item) => {
        // data.detailsId = item.id;
        // console.log(268, data.detailsId);
        // 如果初始化时tasks下的taskDetails下的fieldValues为空
        item.tasks?.forEach((k) => {
          k.taskDetails?.forEach((m) => {
            m?.fieldValues.forEach((n) => {
              // console.log(512, m);
              n['activedInput'] = false;
              // console.log(739, n, k);
              if (k.conditions === 4) {
                data.customerId = n?.value;
              }
              // 数字的需要字符串转数字
              if (m.fieldType === 6) {
                if (n.value?.length > 0) {
                  n['userList'] = n.value.map((item) => item.name);
                  // n.value中的对象替换属性为{ userName: v?.name, id: v?.id, avatarOrigin: v?.avatar }
                  n['userValue'] = n.value.map((v) => {
                    return {
                      userName: v?.name,
                      id: v?.id,
                      avatarOrigin: v?.avatar
                    };
                  });
                  console.log(450, n);
                }
              } else if (m.fieldType === 7 || m.fieldType === 12) {
                n.value = Number(n.value) || n.value;
              } else if (m.fieldType === 8 && n.value) {
                if (m.fieldExt === 'YYYY-M-DD') {
                  n.value = dayjs(n.value).format('YYYY-MM-DD');
                } else if (m.fieldExt === 'YYYY/M/DD') {
                  n.value = dayjs(n.value).format('YYYY/MM/DD ');
                } else {
                  n.value = dayjs(n.value).format(m.fieldExt);
                }
              } else if (m.fieldType === 9 && n.value) {
                n.value = Object.values(JSON.parse(n.value));
              } else if ((m.fieldType === 3 || m.fieldType === 5) && n.value) {
                n.value = n.value.split(',');
              } else if (m.fieldType === 10 && n.value) {
                console.log(502, n.value);
                n.value = n.value.split('/');
              } else if (m.fieldType === 16 && n.value) {
                console.log(512, n);
                n.value = tools.getPrice(n.value);
              } else if (m.fieldType === 18 && tools.isJSON(n.value)) {
                n.value = JSON.parse(n.value);
              } else if (m.fieldType === 22) {
                if (n.value?.length > 0) {
                  n['departList'] = n.value.map((item) => item.name);
                  // n.value中的对象替换属性为{ userName: v?.name, id: v?.id, avatarOrigin: v?.avatar }
                  n['departValue'] = n.value.map((v) => {
                    return {
                      departName: v?.name,
                      id: v?.id
                    };
                  });
                  console.log(451, n);
                }
              } else if (m.fieldType === 23 && tools.isJSON(m.fieldExt)) {
                n.value = tools.getPercentage(n.value, JSON.parse(m.fieldExt)?.numberFormat);
              } else if (m.fieldType === 24) {
                //计算类型
                if (m.fieldExt && tools.isJSON(m?.fieldExt)) {
                  m.fieldExt = JSON.parse(m?.fieldExt);
                  if (m.fieldExt?.type == 6 || m.fieldExt?.type == 16) {
                    //6：汇总金额 16：金额
                    n.value = n.value ? tools.getPrice(n.value, m.fieldExt?.dataType) : '';
                  } else if (m.fieldExt?.type == 23) {
                    //百分比
                    n.value = n.value ? tools.getPercentage(n.value, m.fieldExt?.dataType) : '';
                  } else if (m.fieldExt?.type == 5 || m.fieldExt?.type == 7) {
                    // 数字
                    n.value = !isNaN(parseFloat(n.value)) ? parseFloat(n.value).toFixed(m.fieldExt?.dataType) : '';
                  } else {
                    n.value = n.value ? n.value : '';
                  }
                }
              }
              // else if (m.fieldType === 21) {
              //   console.log(512, m, n);
              //   if (tools.isJSON(m.fieldExt)) {
              //     const pl = JSON.parse(m.fieldExt)?.findAssociateField;
              //     if (data.detailAllFields?.[pl] && data.detailAllFields?.[pl]?.value && data.detailAllFields?.[pl]?.business) {
              //       const params = {
              //         entity: data.detailAllFields?.[pl]?.business,
              //         associateId: data.detailAllFields?.[pl]?.value,
              //         referenceField: JSON.parse(m.fieldExt)?.referenceField
              //       };
              //       getReferenceFieldValue(params).then((res) => {
              //         console.log(656, res);
              //       });
              //     }
              //   }
              // }
            });
          });
        });
        if (o?.currentStage === item.value) {
          data.tasks = formatTasks4Association(item?.tasks);
          data.detailsId = item.id;
          console.log(100, item, data.detailsId);
        }
      });
      // 当处于终极阶段时，结束的按钮展示currentStage为60/70/80
      // if (['60', '70', '80'].indexOf(o?.currentStage) > -1) {
      if (data.finalStageValue.indexOf(o?.currentStage) > -1) {
        // 结束状态，路线上的所有完成按钮和输入框
        data.doneButton = true;
        const endText = o?.details?.find((f) => f.value == o?.currentStage);
        console.log(407, endText);
        // 如果初始化时为终极阶段，需要把结束状态变为激活态
        data.addClass = String(data.progressStage.length - 1);
        console.log(361, data.addClass, data.progressStage.length);
        if (endText) {
          data.endStatus = endText;
          data.endList = endText;
          console.log(323, endText, data.endStatus);
        }
      }
      console.log(189, o?.details);
    } else {
      console.log(res.error?.msg, t('获取数据失败'));
    }
  } catch (e) {
    console.log(375, e.message);
    // Message.error(e.message || e.statusText || t('获取数据失败'));
  }
};

// 过滤审批
const filterApproval = (result) => {
  var resultData = null;
  if (result) {
    result?.details?.forEach((item) => {
      item.tasks = item?.tasks.filter((el) => el.conditions != 3);
    });
    resultData = result;
  }
  console.log('result2', resultData);
  return resultData;
};

// 引用字段值查询接口getReferenceField
//获取引用字段的值
// const getReferenceFieldValue = async (params) => {
//   if (params) {
//     return new Promise((resolve, reject) => {
//       publicService
//         .getReferenceField(params)
//         .then((res) => {
//           if (res.error && res.error?.msg) {
//             Message.error(res.error?.msg || '操作失败');
//           }
//           resolve(res);
//         })
//         .catch((err) => {
//           Message.error(err.message || err.statusText || '获取数据失败');
//           reject(err);
//         });
//     });
//   } else {
//     return [];
//   }
// };
// 增加任务
const addTask = (id) => {
  console.log('新增任务001', id);
  data?.tasks?.forEach((item) => {
    item.taskDetails?.forEach((k) => {
      console.log(k);
      if (k.id === id) k.fieldValues?.push({ label: '', value: '', business: '' });
    });
  });
};
// 删除任务
const removeTask = (id, index) => {
  console.log('删除任务', id, index);
  data?.tasks?.forEach((item) => {
    item.taskDetails?.forEach((k) => {
      if (k.id === id) k.fieldValues?.splice(index, 1);
    });
  });
};
const departTree = ref({
  checkDepartment: true,
  isAll: false,
  data: [], // 数组 必传
  checkUser: false
});
const doneTaskLoading = ref(false);
const activeButtonIndex = ref(null);
//完成任务
const doneTask = async (item, index) => {
  try {
    const done = JSON.parse(JSON.stringify(item.taskDetails));
    console.log(done);
    const scopeDone = [];
    done?.forEach((item, index) => {
      console.log(322, item, item.fieldValues, item.fieldExt);
      if (item.fieldType === 9) {
        // console.log(520, item.fieldValues);
        scopeDone[index] = { field: item.value, fieldType: item.fieldType, fieldValues: item.fieldValues.map((el) => JSON.stringify({ beginDate: el.value[0], endDate: el.value[1] })) };
      } else if (item.fieldType === 10) {
        scopeDone[index] = { field: item.value, fieldType: item.fieldType, fieldValues: item.fieldValues.map((el) => el.value?.join('/')) };
      } else if (item.fieldType === 16) {
        scopeDone[index] = { field: item.value, fieldType: item.fieldType, fieldValues: item.fieldValues.map((el) => tools.setPrice(el.value, item.fieldExt)) };
      } else if (item.fieldType === 12 && item.value == 'customerId') {
        scopeDone[index] = { field: item.value, qccId: item.fieldValues[0].business, fieldType: item.fieldType, fieldValues: item.fieldValues.map((el) => el.value) };
      } else if (item.fieldType === 18) {
        console.log(998, item);
        scopeDone[index] = { field: item.value, fieldType: item.fieldType, fieldValues: [JSON.stringify(...item.fieldValues.map((el) => el.value))] };
      } else if (item.fieldType === 23) {
        scopeDone[index] = { field: item.value, fieldType: item.fieldType, fieldValues: item.fieldValues.map((el) => tools.setPercentage(el.value, JSON.parse(item.fieldExt)?.numberFormat)) };
      } else if (item.fieldType === 24) {
        //计算类型
        // if (item.fieldExt && tools.isJSON(item.fieldExt)) {
        //   item.fieldExt = JSON.parse(item?.fieldExt);
        if (item.fieldExt?.type == 6 || item.fieldExt?.type == 16) {
          //汇总金额
          scopeDone[index] = { field: item.value, fieldType: item.fieldType, fieldValues: item.fieldValues.map((el) => tools.setPrice(el.value)) };
        } else if (item.fieldExt?.type == 23) {
          //百分比
          scopeDone[index] = { field: item.value, fieldType: item.fieldType, fieldValues: item.fieldValues.map((el) => tools.setPercentage(el.value, item.fieldExt?.dataType)) };
        } else {
          scopeDone[index] = { field: item.value, fieldType: item.fieldType, fieldValues: item.fieldValues.map((el) => el.value) };
        }
        // }
      } else {
        //****特殊处理field: item.value,field代表的是云文档/附件中每一项的value值（后台接口返回）,fieldType==item.type（约定好的1代表云文档，2代表附件） ********** *
        // 比如云文档/附件, 云文档的fieldType为1附件的fieldType为2，其他类型的field是代表的是fieldKey
        scopeDone[index] = { field: item.value, fieldType: item.type, fieldValues: item.fieldValues.map((el) => el.value?.toString()) };
      }
    });
    const params = {
      id: data.detailsId,
      taskId: item.id,
      fieldAndValueVos: JSON.parse(JSON.stringify(scopeDone))
    };
    doneTaskLoading.value = true;
    activeButtonIndex.value = index;
    // console.log(322, params);
    const json = await opportunityService.doneTask(params);
    if (!json.error) {
      console.log(json);
      // 刷新列表
      getEntityStage().then(() => {
        // 最后一个完成点击时弹窗确认是否帮助推至下一阶段
        const st = data.allDetail?.details?.find((k) => k.value === data.allDetail.currentStage);
        const sc = st.tasks.map((g) => g.status);
        console.log(14850, sc, data.allDetail);
        const sm = sc?.every((d) => d === '2');
        console.log(14851, sm, data.lastIndex, data.currentStage);
        if (sm && !data.isLastShow) {
          data.stageVisible = true;
        }
        console.log(1128, sm, data.isLastShow);
      });
      Message.success(t('操作成功'));
      doneTaskLoading.value = false;
      emit('cb');
    } else {
      doneTaskLoading.value = false;
      Message.error(t('操作失败'));
    }
  } catch (e) {
    doneTaskLoading.value = false;
    console.log(e);
    // Message.error(e.message || e.statusText || '查询失败');
  }
};

// 点击完成做效验，效验成功提交
const doneApproveTask = async (item) => {
  try {
    let taskId = '';
    console.log(item, taskId);
    item?.taskDetails.map((td) => {
      if (!td.label && !td.value) {
        taskId = td.id;
      }
    });
    const res = await opportunityService.doneApproveTask({ taskId });
    if (!res.error) {
      Message.success(t('操作成功'));
      emit('cb');
    } else {
      Message.error(res.error?.msg || t('操作失败'));
    }
  } catch (e) {
    console.log(e);
  }
};
const finishDoneTask = (item, parentIndex) => {
  //审批任务单独走完成任务逻辑
  if (item.conditions === 3) {
    doneApproveTask(item);
    return false;
  }
  console.log(348, item);
  if (item.conditions === 2) {
    item.taskDetails?.forEach((f) => {
      if (f.type === 2 && f.fieldValues.length > 1) {
        const nullIndex = f.fieldValues.findIndex((k) => !k.value && !k.business);
        console.log(nullIndex);
        f.fieldValues.splice(nullIndex, 1);
      }
    });
  }
  if (item.conditions === 4) {
    if (!item.taskDetails[0]?.fieldValues[0]?.business) {
      Message.error(t('tips.customerIsRequired'));
      return;
    }
  }
  changeEffect(parentIndex);
  if (item.conditions !== 0) {
    let flag = false;
    const d = item?.taskDetails;
    for (let index = 0; index < d.length; index++) {
      const el = d[index].fieldValues;
      if (d[index].fieldType !== 24) {
        for (let j = 0; j < el.length; j++) {
          // const ele = el[j].value;//效验全部
          // console.log('点击完成--',el)
          // const ele = el[0]?.value || el[0]?.value === 0 || el[0].business; //只效验数组的第一个
          // console.log('点击完成333--',ele)
          if (el[0]?.value !== 0 && (el[0]?.value?.length <= 0 || !el[0]?.value)) {
            flag = true;
            break;
          }
        }
        if (flag) break;
      }
    }
    if (flag) {
      console.log('出错了');
    } else {
      console.log('请求');
      doneTask(item, parentIndex);
    }
  } else {
    doneTask(item, parentIndex);
  }

  // else if (item.conditions === 2) {
  //   const arr = [];
  //   item?.taskDetails.forEach((item) => {
  //     // console.log(383, item);
  //     arr.push(item.fieldValues[0].business);
  //   });
  //   console.log(387, arr);
  // }
};
// 失去焦点效验
const changeEffect = (parentIndex, sId) => {
  console.log(651, sId);
  //   if (sId) {
  data.tasks[parentIndex]?.taskDetails?.forEach((actived) => {
    if (actived?.fieldValues && actived?.fieldValues.length > 0) {
      //   console.log(659, actived);
      actived?.fieldValues.forEach((t) => {
        if (actived.fieldType !== 12) {
          // if (t.value && t.value?.length > 0) {
          // console.log('value---', t);
          //   if (t.value) {
          //     t.activedInput = false;
          //   } else {
          t.activedInput = true;
          //   }
          //console.log('value---后', t);
        } else {
          if (t.value) {
            t.activedInput = false;
          } else {
            t.activedInput = true;
          }
        }
      });
    }
  });
  // const actived = record?.taskDetails?.find((v) => v.id === sId);
  // if (actived?.fieldValues && actived?.fieldValues.length > 0) {
  //   console.log(659, actived);
  //   actived?.fieldValues.forEach((t) => {
  //     if (actived.fieldType !== 12) {
  //       // if (t.value && t.value?.length > 0) {
  //       if (t.value || t.value == 0) {
  //         t.activedInput = false;
  //       } else {
  //         t.activedInput = true;
  //       }
  //     } else {
  //       if (t.value) {
  //         t.activedInput = false;
  //       } else {
  //         t.activedInput = true;
  //       }
  //     }
  //   });
  // }
  //   } else {
  // record?.taskDetails?.forEach((k) => {
  //   k.fieldValues.forEach((t) => {
  //     if (!t.value) {
  //       t.activedInput = true;
  //     }
  //   });
  // });
  //   }
};
// 上传成功的回调
const uploadSuccess = (fileItem, item) => {
  console.log(392, item);
  data.disabledUpload = true;
  console.log('文件上传成功', fileItem);
  Message.success(t('上传成功'));
  if (fileItem.response?.code !== 0) {
    console.log(data.fileString);
    Message.error(fileItem.response?.msg || t('上传出错'));
    return;
  } else {
    item.fieldValues.push({ value: fileItem.response?.data, business: fileItem.name, activedInput: true });
    console.log(556, item.fieldValues);
    data.disabledUpload = false;
  }
};
// 改变单选框
const radioGroupChange = (item) => {
  console.log(410, item);
  item.fieldValues = [{ label: null, value: '', business: null, activedInput: false }];
};
// 推进至下一阶段接口
const stageProcessAdvance = async () => {
  let nextStageValue = '';
  if (data.allDetail.currentStage === data.stageProcess) {
    const stageValue = data.progressStage.filter((v) => v.value);
    const stageIndex = stageValue.findIndex((v) => v.value === data.allDetail.currentStage);
    nextStageValue = stageValue[stageIndex + 1]?.value;
    console.log(563, data.progressStage, stageValue, stageIndex, nextStageValue);
  }
  try {
    const params = {
      id: data.stageId,
      stageProcess: data.allDetail.currentStage === data.stageProcess ? nextStageValue : data.stageProcess,
      message: data.form?.reason || undefined
    };
    const json = await opportunityService.stageProcessAdvance(params);
    if (json.error) {
      Message.error(json.error?.msg || t('查询失败'));
      return;
    } else {
      Message.success(t('阶段变更成功') + '！');
      console.log(json);
      data.noCancel = true;
      // 刷新列表
      getEntityStage();
      emit('cb');
    }
  } catch (e) {
    console.log(e);
    // Message.error(e.message || e.statusText || '查询失败');
  }
};
// 弹窗确认
const handleOk = () => {
  formRef.value.handleSubmit();
};
// 弹窗取消
const handleCancel = () => {
  data.visible = false;
  formRef.value.resetFields();
};
// 终极状态的取消(丢单和无效)
const handleCancelStage = () => {
  data.visible = false;
  formRef.value.resetFields();
  data.endStatus = { label: '结束', value: '', status: '0' };
  data.noCancel = false;
};
// 表单提交
const handleSubmit = ({ values, errors }) => {
  console.log('values提交表单', values);
  if (!errors) {
    // 回退至当前阶段
    stageProcessAdvance();
    console.log(123);
  } else {
    console.log('错误处理', errors);
    const errorArray = {};
    Object?.values(errors)?.forEach((key, index) => {
      errorArray[key.field] = { status: 'error', message: '' };
      Object.values(errorArray)?.forEach((i, ind) => {
        if (index === ind) {
          i.message = key.message;
        }
      });
    });
    // formRef.value.setFields(errorArray);
    data.visible = true;
  }
};
// 推进至下一阶段
const moveToNextStage = () => {
  if (data.allDetail.isSupportAcross) {
    stageProcessAdvance();
  } else {
    if (data.boost) {
      stageProcessAdvance();
    } else {
      Message.warning(t('tips.plaseOver'));
    }
  }
};
// 回退至当前阶段
const backToCurrentStage = () => {
  data.visible = true;
  data.form.title = t('tips.backNext');
  data.form.placeholder = t('请输入回退原因');
  formRef.value.resetFields();
  data.form.reason = '';
  // stageProcessAdvance();
};
// 未开始时推进
const noMoveTo = () => {
  Message.warning(t('请先完成上一阶段全部任务'));
};
// 选择结束
const stageEnd = async () => {
  console.log(666, data.endStatus);
  await getList();
  // data.endStatus.value ='60'代表赢单，'70'代表丢单，'80'代表无效
  data.stageProcess = data.endStatus.value;

  // if (data.endStatus.value === '60') {
  //   // data.successVisible = true;
  //   Modal.confirm({
  //     titleAlign: 'start',
  //     width: 400,
  //     simple: false,
  //     title: '温馨提示',
  //     content: data.isPerformance.length ? '请确认是否已赢单？确认后将不可回退' : '请注意，您没有维护商机的业绩分配情况，将影响您后续的绩效统计，是否直接确认赢单？',
  //     onOk: () => {
  //       data.noCancel = true;
  //       stageProcessAdvance();
  //     },
  //     onCancel: () => {
  //       data.endStatus = { label: '结束', value: '', status: '0' };
  //       data.noCancel = false;
  //     }
  //   });
  // } else if (data.endStatus.value === '70') {
  //   data.visible = true;
  //   data.form.reason = '';
  //   data.form.title = '确认是否定为丢单？确认后将不可回退';
  //   data.form.placeholder = '请填写丢单原因';
  // } else if (data.endStatus.value === '80') {
  //   data.visible = true;
  //   data.form.reason = '';
  //   data.form.title = '确认是否定为无效？确认后将不可回退';
  //   data.form.placeholder = '请填写无效原因';
  // }
  data.visible = true;
  data.form.reason = '';
  // data.form.title = `确认是否定为【${data.endStatus?.label}】阶段？确认后将不可回退`;
  data.form.title = t('tips.noBackingOkin', { name: data.endStatus?.label });
  data.form.placeholder = t('请填写阶段变更原因');
};
// 赢单确认弹窗
// const successHandleOk = () => {
//   stageProcessAdvance();
// };
// 任务全部完成时是否推进至下一阶段
const stageHandleOk = () => {
  stageProcessAdvance();
};
const tree = ref({
  checkDepartment: false,
  isAll: true
});

// 添加人员角色--获取部门或者用户的值
const getDeptUser = (v, prop, levelIndex, levelIndex2) => {
  // prop为field值，单一清除时使用
  console.log('人员选择查看:', v, v?.userList, levelIndex, levelIndex2, prop);
  // 选择人员后，调添加人员接口，参数都在v中，按需去V中取

  // data.allDetail?.details?.forEach((item) => {
  // console.log(981, item.tasks);
  // if (levelIndex === i) {
  // 如果初始化时tasks下的taskDetails下的fieldValues不为空
  data.tasks?.forEach((subItem, j) => {
    if (levelIndex === j) {
      subItem.taskDetails?.forEach((m, k) => {
        if (m.fieldType === 6 && levelIndex2 === k) {
          m.fieldValues.forEach((n) => {
            n.userValue = v?.userList;
            n.userList = v?.userList?.map((u) => u.userName);
            n.value = v?.userList?.map((u) => u.id);
          });
        } else if (m.fieldType === 22 && levelIndex2 === k) {
          m.fieldValues.forEach((n) => {
            console.log(1004, n);
            n.departValue = v?.departList;
            n.departList = v?.departList?.map((u) => u.departmentName);
            n.value = v?.departList?.map((u) => u.id);
            console.log(1475, n);
          });
        }
      });
    }
  });
  // });
};
getEntityStage();
// 导出方法
defineExpose({
  getEntityStage
});
</script>
<style scoped lang="less">
@import './index.less';
</style>
